import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconComponent } from '@examdojo/core/icon';
import type { StatTestType } from '../../../../dashboards/data-generator/test-generator/test-library-datasets.model';
import {
  TEST_SELECTOR_GROUPS,
  type TestSelectorGroup,
} from '../../../../dashboards/data-generator/test-generator/test-generator.model';

@Component({
  selector: 'dojo-test-selector',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './test-selector.component.html',
  styleUrl: './test-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestSelectorComponent {
  readonly selected = input.required<StatTestType>();
  readonly testTypeChange = output<StatTestType>();

  readonly groups: readonly TestSelectorGroup[] = TEST_SELECTOR_GROUPS;

  onSelect(type: StatTestType): void {
    this.testTypeChange.emit(type);
  }

  colLabel(count: number): string {
    return count === 1 ? '1 col' : `${count} cols`;
  }
}
